import { getStaticImageSrc } from '#/utils/getImageSrc';

import {
  IdealistLogoHolder,
  IdealistLogoMarkImg,
  IdealistLogoTextImg,
} from './IdealistLogo.styled';

type Props = {
  height: number | { mobile: number; desktop: number };
  withText?: boolean;
};

export function IdealistLogo({ height, withText }: Props) {
  return (
    <IdealistLogoHolder
      $heightMobile={typeof height === 'number' ? height : height.mobile}
      $heightDesktop={typeof height === 'number' ? height : height.desktop}
    >
      <IdealistLogoMarkImg
        src={getStaticImageSrc('logos/logo-mark.webp')}
        alt="Idealist logo"
        width={167}
        height={168}
      />

      {withText && (
        <IdealistLogoTextImg
          src={getStaticImageSrc('logos/logo-idealist.svg')}
          alt="idealist"
          width={348}
          height={168}
        />
      )}
    </IdealistLogoHolder>
  );
}
